export default {
  dataIterator: {
    rowsPerPageText: 'Elementos por página:',
    rowsPerPageAll: 'Todos',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Ningún resultado a mostrar',
    nextPage: 'Página siguiente',
    prevPage: 'Página anterior'
  },
  dataTable: {
    rowsPerPageText: 'Filas por página:'
  },
  noDataText: 'Ningún dato disponible'
}